import { error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchMenusAPI() {
    const response = await fetch(`${baseURL}/api/version2/init/menus`);
    if(!response.ok) throw new error("Failed to retch menus data");
    return response.json()
}